import fetch from '@/utils/fetch';

const api_url = process.env.VUE_APP_API;

// 担当商品池(京东的所有商品)——分页获取商品信息
export const getGoodsPool = (data) => {
  let url = `${api_url}/mall/goods/jdpool/${data.page}/${data.pageCount}`
  if (data.search) {
    url = url + `?search=${data.search}`
  }
  return fetch({
    url: url
  })
};

// 获取商品详情
export const getGoodInfo = data => fetch({
  url: `${api_url}/mall/goods/pool/${data.id}/${data.type}`
});

// 上下架商品列表  page:第几页,从第一页起 pageCount:每页条数 status:0上架,1下架
export const getGoodList = data => {
  let url = `${api_url}/mall/goods/ddbespool/${data.page}/${data.pageCount}/${data.state}`;
  if (data.search) {
    url = url + '?search=' + data.search
  }
  return fetch({
    url: url
  });
};

// 添加商品
export const addGood = data => fetch({
  url: `${api_url}/mall/goods/ddbespool`,
  data,
  method: 'post'
});

// 编辑商品
export const editGoodInfo = data => fetch({
  url: `${api_url}/mall/goods/ddbespool`,
  data,
  method: 'put'
});

// 商品上下架
export const editGoodShelf = data => fetch({
  url: `${api_url}/mall/goods/ddbespool/sale`,
  data,
  method: 'put'
});

// 获取全部订单
export const getAllOrderList = data => fetch({
  url: `${api_url}/mall/order/all`,
  data,
  method: 'post'
});

// 获取对公转账订单
export const getPublicTransferOrder = data => fetch({
  url: `${api_url}/mall/order/publictransfer`,
  data,
  method: 'post'
});

// 确认收货
export const confirmReceipt = orderId => fetch({
  url: `${api_url}/mall/order/confirm?orderId=${orderId}`,
  method: 'post'
});

// 获取待发货订单
export const getNotshippedOrder = data => fetch({
  url: `${api_url}/mall/order/notshipped`,
  data,
  method: 'post'
});

// 发货填写快递信息
export const setExpressage = data => fetch({
  url: `${api_url}/mall/expressage`,
  data,
  method: 'put'
});

// 获取订单详情
export const getOrderDetail = orderId => fetch({
  url: `${api_url}/mall/order/info/${orderId}`
});


// 获取待审核发票列表
export const getUnaudited = data => fetch({
  url: `${api_url}/mall/invoiceTitle/unaudited`,
  data,
  method: 'post'
});

// 获取订单发票申请列表  status 0 未开发票 1已开发票
export const getInvoiceList= data => fetch({
  url: `${api_url}/mall/orderinvoice`,
  data,
  method: 'post'
});

// 获取发票详情
export const getInvoiceDetail = invoiceId => fetch({
  url: `${api_url}/mall/orderInvoice/${invoiceId}`
});

// 审核发票
export const approveInvoice = ({invoiceInfoId,opinion}) => fetch({
  url: `${api_url}/mall/invoiceTitle/unaudited?invoiceInfoId=${invoiceInfoId}&opinion=${opinion}`,
  method: 'post'
})

// 完成开票
export const  setInvoiceOver = invoiceId => fetch({
  url: `${api_url}/mall/orderInvoice/status?invoiceId=${invoiceId}`,
  method: 'post'
});
